import { ReactElement } from 'react';
import {
  SiteSelectListStyle,
  SiteSelectName,
  SiteSelectShortInfo,
  SiteSelectWrapper,
} from './SiteSelect.styled';
import { useCommonTranslation } from '../../../../hooks/i18n/useCommonTranslation';
import { CommonButton } from '../../../common/Forms/Button';
import { SiteByNameModel } from '../../../../types/sites';

interface Props {
  onSiteSelect: (site: SiteByNameModel) => void;
  /**
   * Text for the select button.
   * Defaults to 'select' translation key.
   */
  selectButtonText?: string;
  suggestions: Array<{
    id: string;
    name: string;
    info?: string;
  }>;
}

export const SiteSelectList = ({
  onSiteSelect,
  selectButtonText,
  suggestions,
}: Props): ReactElement => {
  const { t } = useCommonTranslation();

  return (
    <SiteSelectListStyle>
      {suggestions.map((siteInfo, _) => (
        <SiteSelectWrapper key={`site_select_${siteInfo.id}`}>
          <div>
            <SiteSelectName>{siteInfo.name}</SiteSelectName>
            <SiteSelectShortInfo>{siteInfo.info}</SiteSelectShortInfo>
          </div>
          <CommonButton
            style={{
              marginLeft: 'auto',
            }}
            size={'standard'}
            variant={'primary'}
            onClick={() => {
              onSiteSelect(siteInfo);
            }}
            data-testid={`${siteInfo.name}_select_button`}
            type={'submit'}
          >
            {selectButtonText ?? t('select')}
          </CommonButton>
        </SiteSelectWrapper>
      ))}
    </SiteSelectListStyle>
  );
};
